module.exports = __webpack_public_path__ + "img/Logo-Kurier-Color-Tribunal.eb70d5b9.png";